import type { NotificationDeliveryListInput } from '@repo/api-contracts';
import { type ReactElement, useState } from 'react';
import {
  useInvalidateNotifications,
  useNotificationDeliveriesQuery,
} from '@/entities/notification';
import { useResendNotification } from '@/features/notification/resend';
import { PageHeader } from '@/shared/ui';
import { NotificationDeliveryList } from '@/widgets/notification-delivery-list';

const DEFAULT_QUERY: NotificationDeliveryListInput = { page: 1, limit: 20 };

/**
 * 어드민 알림 발송 이력(알림 설계 §6-1). 머리말과 목록 조건(쪽·종류·결과·기간·수신 이메일)만 소유하고, 재발송 쓰기 훅을
 * 위젯에 잇는다. [새로고침]은 발송 이력 캐시 무효화에 잇는다. 도구줄·표·재발송 대화상자는 위젯이 그린다. 참조 칸의 견적·주문 번호는 각 상세(`/quotes/:id`·`/orders/:id`)로 간다.
 * 셸(헤더·사이드바·본문 여백)은 레이아웃 라우트가 준다.
 */
export function NotificationsPage(): ReactElement {
  const [query, setQuery] = useState<NotificationDeliveryListInput>(DEFAULT_QUERY);
  const list = useNotificationDeliveriesQuery(query);
  const resend = useResendNotification();
  const notifications = useInvalidateNotifications();

  return (
    <>
      <PageHeader
        title="알림 발송 이력"
        description="서비스가 보낸 메일의 결과를 확인하고, 실패하거나 건너뛴 알림을 다시 보냅니다."
      />
      <NotificationDeliveryList
        data={list.data}
        initialQuery={query}
        onQueryChange={setQuery}
        onResend={resend}
        onRefresh={() => void notifications.invalidateDeliveries()}
        pending={list.isFetching}
        error={list.isError ? `알림 발송 이력을 불러오지 못했습니다: ${list.error.message}` : null}
      />
    </>
  );
}
